import React from 'react'
import PropTypes from 'prop-types'
import { StripsRenderer } from './StripsRenderer'
import { SIDE_BY_SIDE } from 'LiveBoard/components/shared/SideBySide/constants'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const SideBySide = (props) => {

  const SideBySideTitle = !isEmpty(props.config.title.text) || !isEmpty(props.config.title.subtext)
  const sideBySideText = props.config.title.text
  const sideBySideSubText = props.config.title.subtext

  return props.config.show && (
    <section className={LIVE_BOARD_CLASSNAMES[`${SIDE_BY_SIDE}${props.index+1}`]}>
      { SideBySideTitle && (
          <div className='side-by-side-area-title'>
            <h1>{sideBySideText}</h1>
            <p>{sideBySideSubText}</p>
          </div>
        )
      }
      <StripsRenderer
        isMobile={props.isMobile}
        strips={props.config.strips}
        onItemClick={props.onItemClick}
        themeColorHex={props.themeColorHex} />
    </section>
  )
}

SideBySide.propTypes = {
  config: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  onItemClick: PropTypes.func.isRequired
}

export default SideBySide
